export default __webpack_public_path__ + "static/media/viande.93a26ad8.jpg";